'use client';

import { useState, useEffect } from 'react';
import type { VoteType } from '@repo/common/types';

interface Vote {
  type: VoteType;
  timestamp: number;
}

interface CouponVotes {
  [couponId: string]: Vote;
}

interface UseCouponVotes {
  votes: CouponVotes;
  setVote: (couponId: string, voteType: VoteType) => void;
  getVote: (couponId: string) => VoteType | undefined;
}

export function useCouponVotes(): UseCouponVotes {
  const [votes, setVotesState] = useState<CouponVotes>({});

  useEffect(() => {
    const storedVotes = localStorage.getItem('couponVotes');

    if (storedVotes) {
      setVotesState(JSON.parse(storedVotes));
    }
  }, []);

  const setVote = (couponId: string, voteType: VoteType) => {
    const updatedVotes = {
      ...votes,
      [couponId]: { type: voteType, timestamp: Date.now() },
    };
    setVotesState(updatedVotes);

    localStorage.setItem('couponVotes', JSON.stringify(updatedVotes));
  };

  const getVote = (couponId: string): VoteType | undefined => {
    return votes[couponId]?.type;
  };

  return { votes, setVote, getVote };
}
